import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../shared/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {

    // 1️⃣ Sicherstellen, dass native User (falls vorhanden) in fireUser gespiegelt ist
    await this.auth.ensureNativeUserLoaded();

    const fireUser = this.auth.fireUser;

    const isLoggedIn = !!fireUser && !fireUser.isAnonymous;

    if (!isLoggedIn) {
      this.router.navigate(['/start'], {
        replaceUrl: true,
        queryParams: { returnUrl: state.url }
      });
      return false;
    }

    return true;
  }
}
